import React from 'react';
import { Link } from 'react-router-dom';
import { SELF_PACED_PATH } from './membershipPaths';

/**
 * Shown on the live Bootcamp page only when no live cohort can be bought.
 * Says when the next live class starts (from session rows or catalog cohort
 * metadata, never typed in) and points buyers at the Membership, which is
 * on sale all year.
 */
const MembershipNextStep = ({
  nextStartLabel = null,
  membershipName = null,
  priceLine = null,
  testId = 'live-closed-next-step',
  onClick,
  compact = false,
}) => (
  <div
    className={`cp-next-step${compact ? ' cp-next-step--compact' : ''}`}
    data-testid={testId}
    role="note"
  >
    <p className="cp-next-step-status">
      <strong>Enrollment for this live class is closed.</strong>{' '}
      <span data-testid={`${testId}-date`}>
        {nextStartLabel
          ? `Next live class: ${nextStartLabel}.`
          : 'Next live class: dates coming soon.'}
      </span>
    </p>
    <p className="cp-next-step-copy">
      Start today with {membershipName ? `the ${membershipName}` : 'the Membership'}: every Bootcamp
      recording, a year of BotSpot Pro and live Tuesday Sessions with Rob
      {priceLine ? `, for ${priceLine}` : ''}.
    </p>
    <Link
      className="cp-btn-primary"
      to={SELF_PACED_PATH}
      data-testid={`${testId}-cta`}
      onClick={onClick}
    >
      <span className="cp-btn-label">See the Membership</span>
    </Link>
  </div>
);

export default MembershipNextStep;
